import { Component, OnInit } from '@angular/core';

import { Global } from '../../../../app.global';
import { AlertModel } from '../../viewmodels/alert.model';

import { Constants } from '../../helper/constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
})
export class AlertComponent implements OnInit {
  constants = Constants;

  alerts: Array<AlertModel> = [];
  tooltipPlacement = 'left';

  constructor(public global: Global) {}

  ngOnInit() {
    this.alerts = this.global.alerts;
    this.setTooltipPlacement();
  }

  setTooltipPlacement() {
    if (window.innerWidth <= this.constants.breakpoints.tabletSm) {
      this.tooltipPlacement = 'right';
    }
  }
}
